import { useEffect, useRef, useState } from "react";

const companyInfo = [
	{ label: "会社名", value: "合同会社blackadder" },
	{ label: "代表", value: "宮田浩平 / 小畑和彰（共同代表）" },
	{ label: "法人番号", value: "3011003019957" },
	{
		label: "所在地",
		value: "〒150-0002 東京都渋谷区渋谷2-19-15宮益坂ビルディング609",
	},
	{ label: "設立", value: "2024年9月12日" },
	{ label: "資本金", value: "5,000,000円" },
] as const;

const businessContent = [
	"コンピュータのソフトウェア及びハードウェアの企画、研究、開発、設計、製造、販売、保守、リース、賃貸及び輸出入並びにそれらに関するコンサルティング業務",
	"音声、映像のソフトウェアの企画、制作、販売及び賃貸",
	"ＥＣ（電子商取引）サイト、その他各種ウェブサイトの企画、制作、販売、配信、運営及び管理",
	"各種イベントの企画及び運営の請負",
	"映画、コンサート、演劇、スポーツ、イベント等の各種催物チケットの販売",
	"映画、音楽、美術、演劇、演芸、講演、スポーツ事業その他の文化事業の企画、制作、興行、それらの施設の運営及び請負並びにそれらの関連商品の販売",
	"楽譜の出版、販売及び輸出入",
	"作詞、作曲、編曲及び写譜の受託",
	"前各号に附帯関連する一切の事業",
] as const;

export default function CompanySection() {
	const sectionRef = useRef<HTMLElement>(null);
	const [isVisible, setIsVisible] = useState(false);

	useEffect(() => {
		const element = sectionRef.current;
		if (!element) {
			return;
		}

		if (typeof IntersectionObserver === "undefined") {
			setIsVisible(true);
			return;
		}

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setIsVisible(true);
				}
			},
			{
				threshold: 0.1,
			}
		);

		observer.observe(element);

		return () => {
			observer.disconnect();
		};
	}, []);

	return (
		<section ref={sectionRef} id="company" className="relative py-28 bg-[#0a0a0a]">
			<div className="container px-6 mx-auto">
				<div className="max-w-5xl mx-auto">
					<div className="mb-20">
						<p className="text-xs tracking-[0.3em] uppercase text-neutral-500 mb-4">
							Company
						</p>
						<h2 className="text-3xl md:text-4xl font-light text-white tracking-tight">
							会社情報
						</h2>
					</div>

					{/* Company Info */}
					<div className="mb-20">
						<div className="divide-y divide-white/[0.06]">
							{companyInfo.map((info, index) => (
								<div
									key={info.label}
									className={`grid grid-cols-1 md:grid-cols-4 gap-2 md:gap-6 py-5 transition-all duration-500 ease-out ${
										isVisible
											? "opacity-100 translate-y-0"
											: "opacity-0 translate-y-4"
									}`}
									style={{
										transitionDelay: `${index * 60}ms`,
									}}
								>
									<div className="text-xs tracking-wider text-neutral-500 uppercase md:pt-1">
										{info.label}
									</div>
									<div className="md:col-span-3 text-neutral-200 text-sm leading-relaxed">
										{info.value}
									</div>
								</div>
							))}
						</div>
					</div>

					{/* Business Content */}
					<div className="mb-20">
						<h3
							className={`text-lg font-light text-white mb-8 transition-all duration-500 ease-out ${
								isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
							}`}
							style={{
								transitionDelay: `${companyInfo.length * 60}ms`,
							}}
						>
							事業内容
						</h3>
						<div className="divide-y divide-white/[0.06]">
							{businessContent.map((content, index) => (
								<div
									key={`${index}-${content.slice(0, 12)}`}
									className={`py-4 text-sm text-neutral-400 leading-relaxed transition-all duration-500 ease-out ${
										isVisible
											? "opacity-100 translate-y-0"
											: "opacity-0 translate-y-4"
									}`}
									style={{
										transitionDelay: `${(companyInfo.length + 1 + index) * 50}ms`,
									}}
								>
									{content}
								</div>
							))}
						</div>
					</div>

					{/* Footer */}
					<div
						className={`pt-10 border-t border-white/[0.06] transition-all duration-500 ease-out ${
							isVisible ? "opacity-100" : "opacity-0"
						}`}
						style={{
							transitionDelay: `${(companyInfo.length + 1 + businessContent.length) * 50}ms`,
						}}
					>
						<p className="text-neutral-600 text-xs">
							2024 &copy; blackadder LLC. All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</section>
	);
}
